import React from 'react'
import { connect } from 'react-redux'
import Dialog from '../../common/dialog'
import { cancelUserSubscription, userUpdateRequest } from '../../../../action/user-actions'
import { collapseRightToolbar } from '../../../../action/right-toolbar-state-actions'
import Edit from './edit'
import { photoUploadRequest } from '../../../../action/photo-actions'
import { SUBSCRIPTIONS } from '../../../../lib/enums'
import { showHideSubscriptionModal } from '../../../../utils/subscriptionUtils'

class Profile extends Dialog {
  constructor(props) {
    super(props)
    this.state = {
      editing: false,
      showMenu: false
    }
    this.inputEle = React.createRef()
    this.updatePhoto = this.updatePhoto.bind(this)
    this.handlePhotoUpload = this.handlePhotoUpload.bind(this)
  }

  updatePhoto(e) {
    e.preventDefault()
    this.inputEle.current.click()
  }
  handlePhotoUpload(e) {
    const { photoUploadRequest, userUpdateRequest, user } = this.props,
      file = e.target.files[0]
    if (file) {
      let data = new FormData()
      data.append('file', file)
      let photoInfo = {
        typeId: 2,
        activityId: 1
      }
      photoInfo = JSON.stringify(photoInfo)
      data.append('photoInfo', photoInfo)
      photoUploadRequest(data).then(res => {
        let userInfo = Object.assign({}, user)
        userInfo.photoId = res.id
        delete userInfo.password
        userUpdateRequest(userInfo)
          .then(() => {
            console.log('User Photo Updated')
          })
          .catch((err) => {
            console.error('User Photo Update Failed: ', err)
          })
      })
    }
  }

  render() {
    const { user, collapseRightToolbar, cancelUserSubscription, states, auth } = this.props,
      { editing, showMenu } = this.state,
      stateStr = user.stateId && states.find(state => state.id === user.stateId) ?
        states.find(state => state.id === user.stateId).name : '',
      basicPlan = user.userSubscription.find(plan => plan.subscriptionPlanId === 1),
      proPlan = user.userSubscription.find(plan => plan.subscriptionPlanId === 4),
      proPlanCancel = proPlan && proPlan.cancelDate ? new Date(proPlan.cancelDate).toLocaleDateString() : null,
      proPlanStr = proPlan ? new Date(proPlan.expDate).toLocaleDateString() : 'Not Subscribed',
      proBundlePlan = user.userSubscription.find(plan => plan.subscriptionPlanId === 44),
      proBundlePlanCancel = proBundlePlan && proBundlePlan.cancelDate ? new Date(proBundlePlan.cancelDate).toLocaleDateString() : null,
      proBundlePlanStr = proBundlePlan ? new Date(proBundlePlan.expDate).toLocaleDateString() : 'Not Subscribed',
      grPlan = user.userSubscription.find(plan => plan.subscriptionPlanId === 32 && !plan.cancelDate),
      grPlanCancel = grPlan && grPlan.cancelDate ? new Date(grPlan.cancelDate).toLocaleDateString() : null,
      grString = grPlan ? new Date(grPlan.expDate).toLocaleDateString() : 'Not Subscribed',
      huntPlan = user.userSubscription.find(plan => plan.subscriptionPlanId === 8),
      huntPlanCancel = huntPlan && huntPlan.cancelDate ? new Date(huntPlan.cancelDate).toLocaleDateString() : null,
      huntPlanStr = huntPlan ? new Date(huntPlan.expDate).toLocaleDateString() : 'Not Subscribed',
      userImage = user.imageProfileUrl ? user.imageProfileUrl : '../../../../asset/default-profile.png',
      accessToken = auth

    return (
      <div className='right-expanded-content-container'>
        {/* <div className='right-toolbar-profile-top'>
          <p className='vertical-center'>{new Date().toLocaleDateString()}</p>
          <p className='vertical-center'>Lat/Lng:</p>
          <p className='vertical-center'>Elevation:</p>
        </div> */}
        <div className='right-toolbar-profile-header'>
          <div className='popout-close' style={{ marginTop: '10px' }} onClick={collapseRightToolbar}></div>
          <div className='right-toolbar-profile-header-image'
            style={{ backgroundImage: `url(${userImage})`, backgroundSize: 'cover' }}
          >
            {editing ? (
              <div>
                <div style={{
                  backgroundImage: 'url(../../../../../../../asset/Camera_Solid_4F4F4F_ldpi.png)',
                  backgroundSize: 'cover',
                  position: 'relative',
                  width: '50px',
                  height: '50px',
                  left: '100%',
                  transform: 'translate(-75%, -25%)',
                  cursor: 'pointer'
                }}
                  onClick={this.updatePhoto}>
                </div>
                <input type='file' accept='image/*' ref={this.inputEle} style={{ display: 'none' }} onChange={this.handlePhotoUpload}></input>
              </div>
            ) : null}
          </div>
        </div>
        {
          !editing ? (
            <div className='right-toolbar-profile-info'>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h2 style={{ marginBottom: '20px' }}>{user.fullName}</h2>
                <div className='right-toolbar-profile-edit-btn'
                  onClick={() => { this.setState({ editing: true }) }}>
                </div>
              </div>
              <p style={{ marginBottom: '5px' }}>{`Email: ${user.email}`}</p>
              <p style={{ marginBottom: '5px' }}>{`Phone Number: ${user.phone ? user.phone : ''}`}</p>
              <p style={{ marginBottom: '5px' }}>{`City: ${user.city ? user.city : ''}`}</p>
              <p style={{ marginBottom: '5px' }}>{`State: ${stateStr ? stateStr : ''}`}</p>
              {
                basicPlan && !proBundlePlan && !proPlan && !huntPlan && !grPlan ? (
                  <div className='right-toolbar-profile-info-row'>
                    <p>{SUBSCRIPTIONS.BASIC}</p>

                    <button className='vertical-center'
                      onClick={() => { showHideSubscriptionModal(accessToken) }}
                      style={{ margin: 0, marginRight: '10px', width: '115px', height: '40px' }}>UPGRADE</button>
                  </div>
                ) : null
              }
              {
                proBundlePlan ? (
                  <div className='right-toolbar-profile-info-row'>
                    <p>{SUBSCRIPTIONS.PRO_ULTIMATE}:</p>
                    <p>{`${proBundlePlanCancel ? 'Canceled' : 'Expires'}: ${proBundlePlanCancel ? proBundlePlanCancel : proBundlePlanStr}`}</p>

                    <p style={{
                      display: proBundlePlanCancel ? 'none' : 'inline',
                      cursor: 'pointer',
                      textDecoration: 'underline'
                    }} onClick={() => { cancelUserSubscription(proBundlePlan.id) }}>Cancel</p>
                  </div>
                ) : null
              }
              {
                proPlan ? (
                  <div className='right-toolbar-profile-info-row'>
                    <p>{SUBSCRIPTIONS.PRO}:</p>
                    <p>{`${proPlanCancel ? 'Canceled' : 'Expires'}: ${proPlanCancel ? proPlanCancel : proPlanStr}`}</p>
                    <p style={{
                      cursor: 'pointer',
                      display: proPlanCancel ? 'none' : 'inline',
                      textDecoration: 'underline'
                    }} onClick={() => { cancelUserSubscription(proPlan.id) }}>Cancel</p>
                  </div>
                ) : null
              }

              {
                huntPlan ? (
                  <div className='right-toolbar-profile-info-row'>
                    <p>{SUBSCRIPTIONS.HUNTDATA}:</p>
                    <p>{`${huntPlanCancel ? 'Canceled' : 'Expires'}: ${huntPlanCancel ? huntPlanCancel : huntPlanStr}`}</p>
                    <p style={{
                      cursor: 'pointer',
                      display: huntPlanCancel ? 'none' : 'inline',
                      textDecoration: 'underline'
                    }} onClick={() => { cancelUserSubscription(huntPlan.id) }}>Cancel</p>
                  </div>
                ) : null
              }
              {
                grPlan ? (
                  <div className='right-toolbar-profile-info-row'>
                    <p>{SUBSCRIPTIONS.GLOBAL_RESCUE}:</p>
                    <p>{`${grPlanCancel ? 'Canceled' : 'Expires'}: ${grPlanCancel ? grPlanCancel : grString}`}</p>
                    <p style={{
                      cursor: 'pointer',
                      display: grPlanCancel ? 'none' : 'inline',
                      textDecoration: 'underline'
                    }} onClick={() => { cancelUserSubscription(grPlan.id) }}>Cancel</p>
                  </div>
                ) : null
              }
            </div>
          ) : <Edit cancelEdit={() => { this.setState({ editing: false }) }} />
        }
      </div >
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
  states: state.states,
  auth: state.auth.token
})

const mapDispatchToProps = dispatch => ({
  collapseRightToolbar: () => dispatch(collapseRightToolbar()),
  photoUploadRequest: data => dispatch(photoUploadRequest(data)),
  cancelUserSubscription: id => dispatch(cancelUserSubscription(id)),
  userUpdateRequest: user => dispatch(userUpdateRequest(user))
})

export default connect(mapStateToProps, mapDispatchToProps)(Profile)